import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import type { ModerationCommunity } from '@moderation/domain/ModerationCommunity';
import { PageHeader } from '@soteria/design-system-ve';

export const TIME_RANGE_OPTIONS = [
  { id: '24h', label: 'Last 24 Hours' },
  { id: '48h', label: 'Last 48 Hours' },
  { id: '72h', label: 'Last 72 Hours' },
] as const;

export type TimeRange = (typeof TIME_RANGE_OPTIONS)[number]['id'];

export interface ModerationStats {
  totalCases: number;
  casesOpen: number;
  activeModerators: number;
  casesCompleted: number;
}

// Default stats constant to avoid recreating object on every render
// Using zeros to avoid misleading users with fake data when stats aren't available
export const DEFAULT_MODERATION_STATS: ModerationStats = {
  totalCases: 0,
  casesOpen: 0,
  activeModerators: 0,
  casesCompleted: 0,
};

interface CommunityModerationHeaderSectionProps {
  community: ModerationCommunity | null;
}

/**
 * Header section component for moderation pages.
 * Renders a PageHeader with the community moderation title.
 */
function CommunityModerationHeaderSectionComponent({ community }: CommunityModerationHeaderSectionProps) {
  const name = community?.name || '';

  return <PageHeader data-testid="community-moderation-header-v2" title={`${name} Moderation`} />;
}

export const CommunityModerationHeaderSection = withAppInsightsTracking(CommunityModerationHeaderSectionComponent, 'CommunityModerationHeaderSection');
